import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="faq-paises"
// Sincroniza el checkbox "Todos los países" con los checkboxes de país individuales:
// al marcarlo, marca y deshabilita todos los países; al desmarcarlo, los libera.
export default class extends Controller {
  static targets = ["todos", "pais"]

  connect() {
    this.sincronizar()
  }

  sincronizar() {
    const todos = this.todosTarget.checked
    this.paisTargets.forEach(pais => {
      if (todos) pais.checked = true
      pais.disabled = todos
    })
  }
}
